export default __webpack_public_path__ + "static/media/F1_7.e9654fe3.png";